<template>
  <div class="page-container">
    <div class="signup-container">
      <img src="../assets/full.svg" class="logo" />
      <div class="signup-text">Sign up</div>
      <v-form class="signup-form" v-model="isFormValid">
        <!-- all input elements go here -->
        <v-text-field class="first-name my-3" v-model="firstName" autocomplete="given-name" ref="firstName" label="First Name" :rules="notEmptyRules" hide-details="auto"></v-text-field>
        <v-text-field class="last-name my-3" v-model="lastName" autocomplete="family-name" ref="lastName" label="Last Name" :rules="notEmptyRules" hide-details="auto"></v-text-field>
        <v-text-field class="email my-3" v-model="email" ref="email" autocomplete="username" label="Email" :rules="emailRules" hide-details="auto"></v-text-field>
        <v-text-field class="password my-3" v-model="password" autocomplete="new-password" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" ref="password" label="Password" :rules="notEmptyRules" hide-details="auto"></v-text-field>
        <v-text-field class="confirm-password my-3" v-model="passwordConfirm" autocomplete="new-password" :type="showConfirmPassword ? 'text' : 'password'" :rules="confirmPasswordRules.concat(passwordConfirmationRule)" :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showConfirmPassword = !showConfirmPassword" ref="password" label="Confirm Password" hide-details="auto"></v-text-field>
        <v-btn type="submit" :disabled="!isFormValid || loading" :loading="loading" @click="submit" class="signup-button" color="#5774E7" width="300px" height="38px">Sign up</v-btn>
      </v-form>

      <div class="bottom-text">Already have an account? <a class="login-link" @click="$router.push('login')">Log in</a></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SignUp",
  mounted() {
  },
  methods: {
    loader() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$toast.success("Signed up");
      }, 1000);
    },

    submit() {
      this.loading = true;
      const data = { firstName: this.firstName, lastName: this.lastName, email: this.email, password: this.password, url: window.location.origin + "/#" };
      axios
        .post(this.$store.state.serverURL + "/users/signup", data)
        .then((res) => {
          this.loading = false;
          this.$toast.success("Successful creation of an account, please verify your email", { position: "bottom-right", timeout: 7500 });
          this.$router.push("/login");
        })
        .catch((err) => {
          this.loading = false;
            this.$toast.error(err.response.data.message, { position: "bottom-right", timeout: 7500 });
        });
    },
    clear() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.password = "";
    },
  },
  computed: {
    passwordConfirmationRule() {
      return () => this.password === this.passwordConfirm || "Password must match";
    },
  },
  data: () => ({
    loading: false,
    isFormValid: true,
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    passwordConfirm: "",
    showPassword: false,
    showConfirmPassword: false,

    emailRules: [
      (value) => !!value || "Required.",
      (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    notEmptyRules: [(value) => !!value || "Required."],
    confirmPasswordRules: [(v) => !!v || "Password is required"],
  }),
};
</script>

<style scoped>
.signup-form {
  position: absolute;
  top: 130px;
  width: 300px;
}

.page-container {
  width: 100%;
  height: 100%;
}
.signup-container {
  background-color: white;
  width: 380px;
  height: 620px;
  box-shadow: 0px 2px 4px rgba(0, 41, 199, 0.2);
  border-radius: 4px;

  position: absolute;
  top: calc(50% - 307px);
  left: calc(50% - 190px);

  display: flex;
  justify-content: center;
}

.signup-text {
  position: absolute;

  top: 100px;

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;

  color: #202060;
}

.logo {
  position: absolute;
  top: 40px;
}

.signup-button {
  color: white;
  border-radius: 4px;
  top: 375px;
}

.bottom-text {
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 16px;
  /* identical to box height, or 123% */

  text-align: center;
  /* Grey / 400 */
  position: absolute;
  color: #808080;
  top: 573px;
}

a.login-link {
  color: #5774e7;
}

.email {
  position: absolute;
  top: 140px;
  width: 100%;
}

.first-name {
  position: absolute;
  top: 0px;
  width: 100%;
}

.last-name {
  position: absolute;
  top: 70px;
  width: 100%;
}

.password {
  position: absolute;
  top: 210px;
  width: 100%;
}

.confirm-password {
  position: absolute;
  top: 280px;
  width: 100%;
}
</style>
